import { render } from "./index.vue?vue&type=template&id=622960b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=622960b8&scoped=true&lang=scss"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622960b8"]])

export default __exports__